<div class="row__avatar">
  <img class="avatar" src="{{url}}" alt='Avatar image' />
  <span class="label">{{text}}</span>
</div>